import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Scanner extends ClickElement {
  submitOnEnter = true;
  placeholder = '';

  constructor() {
    super();
    this.elementType = ElementType.scanner;
    this.submitOnEnter = true;
    this.placeholder = '';
  }
}
